import { hideSidebar, Sidebar } from '@components/sidebar';

import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { ACTION_TYPES } from 'ui/actions/action-config';
import {
  ActionHeader,
  ActionSidebarLoading,
  SidebarProps,
} from 'ui/journey-builder/node-types/common';

import { WaitForAttributeChangeFormContent } from './helpers';

const ACTION_TYPE = ACTION_TYPES.wait_for_attribute_change;

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;

  const editMutation = useUpdateJourneyAction(journeyActionId);

  const { data, isLoading } = useJourneyAction<typeof ACTION_TYPE>(journeyActionId);

  if (isLoading || !data) {
    return <ActionSidebarLoading actionType={ACTION_TYPE} {...props} />;
  }

  return (
    <Sidebar>
      <ActionHeader actionType={ACTION_TYPE} {...props} />
      <Sidebar.Content>
        <WaitForAttributeChangeFormContent
          action={data}
          journeyId={data.journey}
          onCancel={hideSidebar}
          onSubmit={(submitData) =>
            editMutation.mutateAsync({
              isAutomatic: true,
              action: ACTION_TYPE,
              values: submitData,
              description: submitData.description ?? '',
            })
          }
        />
      </Sidebar.Content>
    </Sidebar>
  );
};
